import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Message,
  Grid,
  Row,
  Col,
  Container,
  Header,
  Content,
  Footer,
  Sidebar,
  Table,
  Icon,
  FlexboxGrid,
  IconButton,
} from 'rsuite'

export default function ContractSignTypeWidgets({ schema }) {
  const [formSchema, setFormSchema] = useState(schema)
  const { Column, HeaderCell, Cell } = Table

  const renderThaiHealthWitness = formSchema?.thaiHealthWitness?.values?.map((item, index) => {
    return (
      <p style={{ marginLeft: 25 }}>
        พยาน {index + 1} {item.honorific} {item.firstName} {item.lastName}
      </p>
    )
  })

  const renderGranteeWitness = formSchema?.granteeWitness?.values?.map((item, index) => {
    return (
      <p style={{ marginLeft: 25 }}>
        พยาน {index + 1} {item.honorific} {item.firstName} {item.lastName}
      </p>
    )
  })
  return (
    <>
      <Panel
        shaded
        header={formSchema.contractSignType.header}
        bordered
        collapsible
        defaultExpanded
      >
        <p>
          <b>{formSchema.contractSignType.label}</b>
        </p>

        <br />

        {formSchema.contractSignType.value == 2 && (
          <>
            <p>{formSchema?.thaiHealthWitness?.header}</p>
            {formSchema?.thaiHealthWitness?.values.length > 0 ? (
              renderThaiHealthWitness
            ) : (
              <p style={{ marginLeft: 25 }}>ไม่พบพยาน</p>
            )}

            <br />

            <p>{formSchema?.granteeWitness?.header}</p>
            {formSchema?.granteeWitness?.values.length > 0 ? (
              renderGranteeWitness
            ) : (
              <p style={{ marginLeft: 25 }}>ไม่พบพยาน</p>
            )}
          </>
        )}
      </Panel>
      <br />
    </>
  )
}
